import React, {useContext, useEffect, useState, useMemo} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {ENTITY_ID_VEHICLE_MODEL} from "../generic/Constants";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {VehicleModelAddEditDialog} from "./VehicleModelAddEditDialog";
import {VEHICLE_SEGMENT_LIST} from "../generic/VehicleSegmentList";
import {BrandImageFormatter} from "../../column-formatters/BrandImageFormatter";
import {VehicleSegmentFormatter} from "../../column-formatters/VehicleSegmentFormatter";
import {OEM_LIST} from "../generic/OEMList";

export function VehicleModelsPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const columns = [
        {
            dataField: "id",
            text: "Id",
            hidden: true
        }, {
            dataField: "oem",
            text: "OEM",
            formatter: BrandImageFormatter,
            formatExtraData: {
                size: '40px',
                imgSize: '30px'
            },
        },
        {
            dataField: "model",
            text: "Model",
            search: true
        },
        {
            dataField: "vehicleSegment",
            text: "Vehicle Segment",
            formatter: VehicleSegmentFormatter,
            showInMobile: false,
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal(true);
    }

    function reloadData() {
        setReload(reload + 1);
    }

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete the Vehicle Model? You will be able to delete it only if it is not used anywhere.");
        if (result) {
            genericDelete(ENTITY_ID_VEHICLE_MODEL, row.id).then(() => {
                showToast("Vehicle Model is Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
                }
            ).finally(() => {
                reloadData();
            });
        }
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = (shouldReload = false) => {
        setShowModal(false);
        if (shouldReload) {
            reloadData();
        }
    };

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "ADD VEHICLE MODEL",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    const filters = useMemo(() => [
        {
            dataField: "oem",
            text: "OEM",
            options: OEM_LIST.filter(oem => oem.id !== 'OTHER')
        },
        {
            dataField: "vehicleSegment",
            text: "Vehicle Segment",
            options: VEHICLE_SEGMENT_LIST
        }
    ], []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Vehicle Models</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_VEHICLE_MODEL}
                        filters={filters}
                    />
                )}
            </div>
            <VehicleModelAddEditDialog show={showModal} handleClose={handleClose} id={showModelId}/>
        </>
    );
}
